import { NetworkRequestException } from '../../../exceptions/networkRequestException';
import { defaultErrorToTerm } from '../../../otherBusinessLogic/defaultErrorToTerm';

export function errorToTerm(exception: unknown): string {
  if (exception instanceof NetworkRequestException) {
    switch (exception.status) {
      case 429:
        return 'toggle_vm_already_occurring';
    }
  }

  return defaultErrorToTerm(exception) ?? 'toggle_vm_unknown_error';
}
